import { render, staticRenderFns } from "./GauravImpexLogo.vue?vue&type=template&id=11cd2903&"
import script from "./GauravImpexLogo.vue?vue&type=script&lang=js&"
export * from "./GauravImpexLogo.vue?vue&type=script&lang=js&"
import style0 from "./GauravImpexLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports